import type { Dispatch, SetStateAction } from "react";
import { DashboardFilterMenu } from "../../../components/Filter/DashboardFilters";
import HeaderFilterTrigger from "./HeaderFilterTrigger";
import { useHoverOpenMenu } from "../_hooks/useHoverOpenMenu";

type StatusOption = { label: string; value: string; subSort: string };

type Props = {
  label?: string;
  value: StatusOption[];
  onChange: Dispatch<SetStateAction<StatusOption[]>>;
  onClear: () => void;
  filterByOptions: StatusOption[];
};

/**
 * "Status" column header: hovering opens the status filter menu (same options
 * and same `searchBy` state as the toolbar funnel). The menu stays open until
 * the user clicks outside it or presses Escape.
 */
export default function StatusHeaderFilter({
  label = "Status",
  value,
  onChange,
  onClear,
  filterByOptions,
}: Props) {
  const menu = useHoverOpenMenu<HTMLDivElement>();

  return (
    <>
      <HeaderFilterTrigger
        {...menu.triggerProps}
        label={label}
        activeCount={value?.length ?? 0}
      />
      <DashboardFilterMenu
        anchorEl={menu.anchorEl}
        open={menu.isOpen}
        onClose={menu.close}
        onChange={onChange}
        onClear={onClear}
        value={value}
        filterByOptions={filterByOptions}
        hideIncludeArchive
        disableAutoFocusItem
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
      />
    </>
  );
}
